import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import LoadingButton from '@/Shared/LoadingButton';
import TrashedMessage from '@/Shared/TrashedMessage';
export default {
  components: {
    Head: Head,
    Link: Link,
    LoadingButton: LoadingButton,
    SelectInput: SelectInput,
    TextInput: TextInput,
    TrashedMessage: TrashedMessage
  },
  layout: Layout,
  props: {
    contact: Object,
    organizations: Array
  },
  remember: 'form',
  data: function data() {
    return {
      form: this.$inertia.form({
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        organization_id: this.contact.organization_id,
        email: this.contact.email,
        phone: this.contact.phone,
        address: this.contact.address,
        city: this.contact.city,
        region: this.contact.region,
        country: this.contact.country,
        postal_code: this.contact.postal_code
      })
    };
  },
  methods: {
    update: function update() {
      this.form.put("/campaigns/".concat(this.contact.id));
    },
    destroy: function destroy() {
      if (confirm('Are you sure you want to delete this contact?')) {
        this.$inertia["delete"]("/campaigns/".concat(this.contact.id));
      }
    },
    restore: function restore() {
      if (confirm('Are you sure you want to restore this contact?')) {
        this.$inertia.put("/campaigns/".concat(this.contact.id, "/restore"));
      }
    }
  }
};